import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import Hero from '../../sections/Hero';
import QuoteRequestForm from '../../sections/QuoteRequestForm';

const PricingPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Pricing</title>
        <meta
          name="description"
          content="Transparent and competitive pricing for delivery, junk removal, and moving services in Northeast Wisconsin."
        />
      </Helmet>

      <Hero 
        title="Our Pricing"
        subtitle="Transparent and competitive rates for all our services"
        backgroundImage="/assets/images/pricing-bg.jpg"
        showQuickForm={false}
      />

      <Box component="section" py={8}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h2" gutterBottom align="center">
            Simple and Transparent Pricing
          </Typography>
          <Typography variant="body1" paragraph align="center" sx={{ mb: 6 }}>
            At JBR Delivery LLC, we believe in providing clear and straightforward pricing for all our services. Rates may vary based on distance, size, and specific requirements.
          </Typography>
          
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Card elevation={3}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h5" component="h3" gutterBottom>
                    Delivery Services
                  </Typography>
                  <Typography variant="body1" paragraph>
                    Our delivery services start at $75, with final pricing based on distance, item size, and any special handling requirements.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Card elevation={3}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h5" component="h3" gutterBottom>
                    Junk Removal
                  </Typography>
                  <Typography variant="body1" paragraph>
                    Junk removal services start at $100, with pricing based on volume, weight, and disposal requirements.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Card elevation={3}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h5" component="h3" gutterBottom>
                    Moving Services
                  </Typography>
                  <Typography variant="body1" paragraph>
                    Moving services start at $150, with final pricing based on distance, volume, and any additional services required.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          
          <Box mt={6}>
            <Typography variant="body1" paragraph>
              For the most accurate pricing tailored to your specific needs, please contact us for a personalized quote. We're committed to providing competitive rates while maintaining the highest quality of service.
            </Typography>
          </Box>
        </Container>
      </Box>

      <QuoteRequestForm />
    </>
  );
};

export default PricingPage;
